import React, { FC } from "react";

// This is just an example of how we could do middleware stuff like checking auth.
const ExampleMiddleware: FC = (props) => {
    return <>{props.children}</>;
};

export default ExampleMiddleware;
